import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { payAllCommissions as pay } from "MODULES/Commissions/actions";
import { searchAllUsers } from "MODULES/users/actions";
import Form from "./Form";

export class PayAll extends Component {
  state = {
    employees: []
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.updateEmployees();
    }
  }

  initialValues() {
    return { filters: this.props.filters, commissions: {} };
  }

  updateEmployees() {
    this.props
      .searchAllUsers({
        open_commission_users: true,
        commission_filter: this.props.filters.filter,
        page: 1,
        sort: "first_name",
        reverse: false,
        limit: 1000
      })
      .then(resp => {
        this.setState({ employees: resp });
      });
  }

  render() {
    const { open, close, onSubmit } = this.props;
    const { employees } = this.state;
    return (
      <Modal dialogClass="modal-lg" open={open} close={close}>
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Pay All Commissions</h4>
        </Header>
        <Form
          initialValues={this.initialValues()}
          employees={employees}
          close={close}
          onSubmit={onSubmit}
        />
      </Modal>
    );
  }
}

PayAll.propTypes = {
  filters: PropTypes.shape({
    filter: PropTypes.string
  }),
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  searchAllUsers: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default connect(
  state => ({
    filters: state.commissions.get("filters").toJS()
  }),
  dispatch => ({
    onSubmit: data => dispatch(pay(data)),
    searchAllUsers: params => dispatch(searchAllUsers(params))
  })
)(PayAll);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/PayAll/PayAll.jsx